import { createTheme } from '@mui/material/styles';

export const getAppTheme = (isDarkMode) => createTheme({
  palette: {
    mode: isDarkMode ? 'dark' : 'light',
    background: {
      default: isDarkMode ? '#3c3c3c' : '#ffffff',
      paper: isDarkMode ? '#2a2a2a' : '#ffffff',
    },
    text: {
      primary: isDarkMode ? '#ffffff' : '#000000',
    },
    primary: {
      main: isDarkMode ? '#ffffff' : '#000000',
    },
  },
});
